import { useRef, useCallback, useMemo } from 'react';

const useBudget = ({ dispatch, value, currencyCode }) => {
  const ref = useRef(null);

  const onChange = useCallback(
    (budget) => {
      dispatch({ type: 'BUDGET_CHANGE', payload: budget });
    },
    [dispatch]
  );

  const onClear = useCallback(() => {
    dispatch({ type: 'BUDGET_CLEAR' });
  }, [dispatch]);

  const clear = useCallback(() => {
    if (ref.current && ref.current.reset) {
      ref.current.reset();
    }
  }, []);

  const reset = useCallback(() => {
    dispatch({ type: 'BUDGET_CLEAR' });
    clear();
  }, [clear, dispatch]);

  return useMemo(
    () => ({ value, defaultValue: value, onChange, onClear, ref, reset, clear, currencyCode }),
    [clear, currencyCode, onChange, onClear, reset, value]
  );
};

export default useBudget;
